import { render, staticRenderFns } from "./WithHolding-detail.vue?vue&type=template&id=5d49a2a9"
import script from "./WithHolding-detail.vue?vue&type=script&lang=js"
export * from "./WithHolding-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports